const DATABASE_NAME = 'ticklegram-comments-cache';
const DATABASE_VERSION = 1;
const STORE_NAME = 'platform-threads';
const MAX_CACHE_AGE_MS = 24 * 60 * 60 * 1000;

const openDatabase = () => new Promise((resolve, reject) => {
  if (typeof indexedDB === 'undefined') {
    resolve(null);
    return;
  }

  const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
  request.onupgradeneeded = () => {
    const database = request.result;
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      database.createObjectStore(STORE_NAME, { keyPath: 'key' });
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const withStore = async (mode, callback) => {
  const database = await openDatabase();
  if (!database) return null;

  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, mode);
      const store = transaction.objectStore(STORE_NAME);
      const request = callback(store);
      request.onsuccess = () => resolve(request.result ?? null);
      request.onerror = () => reject(request.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    database.close();
  }
};

const cacheKey = (scope, platform) => `${scope || 'anonymous'}:${platform}`;

export const readCommentsCache = async (scope, platform) => {
  try {
    const record = await withStore('readonly', (store) => store.get(cacheKey(scope, platform)));
    if (!record || !Array.isArray(record.threads)) return null;
    if (Date.now() - Number(record.savedAt || 0) > MAX_CACHE_AGE_MS) return null;
    return record;
  } catch (error) {
    console.warn('Unable to read the comments cache:', error);
    return null;
  }
};

export const writeCommentsCache = async (scope, platform, threads) => {
  try {
    const record = {
      key: cacheKey(scope, platform),
      platform,
      savedAt: Date.now(),
      threads,
    };
    await withStore('readwrite', (store) => store.put(record));
    return record;
  } catch (error) {
    console.warn('Unable to update the comments cache:', error);
    return null;
  }
};
